import convertObjectToFormData from "../utils/convertObjectToFormData";
import config from '../config';

export async function fetchProviderInfo(providerId, token) {
    const response = await fetch(`${config.API_URL}/provider`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'provider_id': providerId // only used if user is ADMIN
        }
    })
    if (response.status !== 200) {
        throw Error('Failed to update');
    }
    const data = await response.json();
    return data;
}
export async function addProviderInfo(providerId, providerInfo, token) {
    console.log(providerInfo);
    // We need to convert the JSON object to FormData so that we can attach image
    const formData = convertObjectToFormData(providerInfo)

    const res = await fetch(`${config.API_URL}/provider`, {
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }

    const body = await res.json();
    console.log(body)
    return body;
}

export async function deleteProviderInfo(providerId, token) {
    const res = await fetch(`${config.API_URL}/provider`, {
        method: 'delete',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId
        },
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}


export async function addConnectionToProvider(providerId, actions, token) {

    const res = await fetch(`${config.API_URL}/provider/connection`, {
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId
        },
        body: JSON.stringify({actions: actions})
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }

    const body = await res.json();
    console.log(body)
    return body;
}

export async function validateProvider(providerId, isValidated, token){
    const formData = convertObjectToFormData({ providerId, isValidated })

    const res = await fetch(`${config.API_URL}/provider/validate-provider`, {
        method: 'put',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
        },
        body: formData
    });

    if ( res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}